module.exports = __webpack_public_path__ + "static/media/thumb.cc96e18b.jpeg";